export default {"src":"/_next/static/media/seller-obligations.b6ed14e7.svg","height":156,"width":182,"blurWidth":0,"blurHeight":0};